import manifest from "@/lib/imageManifest.json";

export const imageSrcSet = (src) => {
  const widths = typeof src === "string" ? manifest[src] : undefined;
  if (!widths) return undefined;
  const stem = src.replace(/^\/images\//, "").replace(/\.[a-z]+$/i, "");
  return widths.map((w) => `/images/opt/${stem}-${w}.webp ${w}w`).join(", ");
};

export const Img = ({ src, sizes = "100vw", ...props }) => {
  const srcSet = imageSrcSet(src);
  return <img src={src} srcSet={srcSet} sizes={srcSet ? sizes : undefined} decoding="async" {...props} />;
};
